module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "id": "title83"
    }
  }), _c('div', {
    staticClass: "title-toc"
  }, [_vm._v("Table of Contents")]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_titlePage",
    attrs: {
      "href": "#/e9781429988070_tp01",
      "id": "toctitle79",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Title Page")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_epigraphPage",
    attrs: {
      "href": "#/e9781429988070_epi01",
      "id": "toctitle82",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Epigraph")])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429988070_p01",
      "id": "toctitle1"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part One")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c01",
      "id": "toctitle2"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Dangerous Summer’s Night")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c02",
      "id": "toctitle3"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Its Long Life")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c03",
      "id": "toctitle4"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The First Years")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429988070_p02",
      "id": "toctitle5"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Two")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c04",
      "id": "toctitle6"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Escape from the Dead Zone")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c05",
      "id": "toctitle7"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bright College Years")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c06",
      "id": "toctitle8"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Girl and Her Bike")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c07",
      "id": "toctitle9"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Overland, to a Strange Piece of Paradise")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c08",
      "id": "toctitle10"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Seven Days")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title11",
      "id": "toctitle11"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day One: June 16")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title12",
      "id": "toctitle12"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Two: June 17")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title13",
      "id": "toctitle13"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Three: June 18")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title14",
      "id": "toctitle14"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Four: June 19")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title15",
      "id": "toctitle15"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Five: June 20")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title16",
      "id": "toctitle16"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Six: June 21")])])]), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c08#title17",
      "id": "toctitle17"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Day Seven: June 22")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c09",
      "id": "toctitle18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cline Falls")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c10",
      "id": "toctitle19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Orygun, 1992")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c11",
      "id": "toctitle20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Dreamscape, Deathscape")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c12",
      "id": "toctitle21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acts of Will")]), _vm._v(" (June 22, 1977, Night)")])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c13",
      "id": "toctitle22",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Leaving Cline Falls, 1992")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c14",
      "id": "toctitle23",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Alive")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c15",
      "id": "toctitle24",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Afterlife")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_section1",
    attrs: {
      "href": "#/e9781429988070_c15#title25",
      "id": "toctitle25",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("July 17, 1977")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c16",
      "id": "toctitle26",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Not Mine Alone")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c17",
      "id": "toctitle27",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Near the Apex of the Turning Tire Impressions Was a Large Quantity of Blood")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c18",
      "id": "toctitle28",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Specifics of the Atrocity")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c19",
      "id": "toctitle29",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("My Little Buddy")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c20",
      "id": "toctitle30",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sisters and Cowboys")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c21",
      "id": "toctitle31",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Watch Your Back")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c22",
      "id": "toctitle32",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Boo")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c23",
      "id": "toctitle33",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Billy")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c24",
      "id": "toctitle34",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Billy Don’t Do Dark")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c25",
      "id": "toctitle35",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Pre-Axe and Post-Axe")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429988070_p03",
      "id": "toctitle36",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Three")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c26",
      "id": "toctitle37",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Allies")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c27",
      "id": "toctitle38",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Turn of the Screw")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c28",
      "id": "toctitle39",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Hot Rocks")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c29",
      "id": "toctitle40",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Hatchet-in-the-River Hoax and Other Rumors")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c30",
      "id": "toctitle41",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("First Murder in a Little Town")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c31",
      "id": "toctitle42",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Other Woman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c32",
      "id": "toctitle43",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Deep Breath in a Dark Place")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c33",
      "id": "toctitle44",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bibles, Blades, and Blood")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c34",
      "id": "toctitle45",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Blood on File")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c35",
      "id": "toctitle46",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Desert Dust")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c36",
      "id": "toctitle47",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("What the Birdman Saw")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c37",
      "id": "toctitle48",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Trip Back to the Midwest")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c38",
      "id": "toctitle49",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("God Is My Witness")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c39",
      "id": "toctitle50",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Ditchdigger’s Bosses")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c40",
      "id": "toctitle51",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Axe Choppin’ Program")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c41",
      "id": "toctitle52",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Cowboy Movie Star")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c42",
      "id": "toctitle53",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Other Women")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c43",
      "id": "toctitle54",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_c('em', {
    staticClass: "i"
  }, [_vm._v("Evil")]), _vm._v(" Equals "), _c('em', {
    staticClass: "i"
  }, [_vm._v("Live")]), _vm._v(" Spelled Backward")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c44",
      "id": "toctitle55",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Severed")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c45",
      "id": "toctitle56",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Bonding Hard")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c46",
      "id": "toctitle57",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Western Trees Bear Strange Fruit")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c47",
      "id": "toctitle58",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Some Words with an Axeman")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c48",
      "id": "toctitle59",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Suffocating in Juniper")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c49",
      "id": "toctitle60",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Moans at Okinawa")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c50",
      "id": "toctitle61",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Antichrist Asks for an Attorney")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c51",
      "id": "toctitle62",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Clues from Two Felons")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c52",
      "id": "toctitle63",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Immediate Family")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c53",
      "id": "toctitle64",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Sleuth Reappears")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c54",
      "id": "toctitle65",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Missing Muscle")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c55",
      "id": "toctitle66",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Sisters of Mercy")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c56",
      "id": "toctitle67",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("How Long Till You’re Innocent?")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c57",
      "id": "toctitle68",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Red Lipstick on a White Scar")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c58",
      "id": "toctitle69",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Skinned Alive")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c59",
      "id": "toctitle70",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("A Scary Guy Goes Down")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_part",
    attrs: {
      "href": "#/e9781429988070_p04",
      "id": "toctitle71",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Part Four")])])]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c60",
      "id": "toctitle72",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Memory on Fire")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c61",
      "id": "toctitle73",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Chopped-up Traveling Angel")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c62",
      "id": "toctitle74",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Last Sister")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c63",
      "id": "toctitle75",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Tale That Came Back to Me")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_chapter",
    attrs: {
      "href": "#/e9781429988070_c64",
      "id": "toctitle76",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("The Tale That Continues On")])])]), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "toc_entry"
  }, [_c('span', {
    staticClass: "toc_entry_backMatter",
    attrs: {
      "href": "#/e9781429988070_bm02",
      "id": "toctitle77",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Author’s Note")])])]), _c('br'), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_acknowPage",
    attrs: {
      "href": "#/e9781429988070_ack01",
      "id": "toctitle78",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_c('strong', {
    staticClass: "b"
  }, [_vm._v("Acknowledgments")])])]), _c('br'), _vm._v(" "), _c('span', {
    staticClass: "toc_entry_pubInfo",
    attrs: {
      "href": "#/e9781429988070_cop01",
      "id": "toctitle80",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', [_vm._v("Copyright Page")])]), _c('br')])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e7b02fe0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/e9781429988070_toc01.vue
// module id = 69
// module chunks = 0